import useFetch from '../../../hooks/useFetch';
import { useState } from 'react';
import { SalesOrderDetailFilters } from '../../models/SalesOrderDetail';
import { ServiceEvents } from '../shared/interfaces';
import { EndPoints } from '../EndPoints';

const useSalesOrderDetailService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetSalesOrderDetails, setFetchingGetSalesOrderDetails] = useState(false);
    const [fetchingStoreSalesOrderDetail, setFetchingStoreSalesOrderDetail] = useState(false);
    const [fetchingUpdateSalesOrderDetail, setFetchingUpdateSalesOrderDetail] = useState(false);
    const [fetchingDeleteSalesOrderDetail, setFetchingDeleteSalesOrderDetail] = useState(false);

    // GET - Listar detalles de una orden de venta
    const getSalesOrderDetails = (filter: SalesOrderDetailFilters, events: ServiceEvents = {}) => {
        const queryString = Object.entries(filter)
            .filter(([, value]) => value !== null && value !== undefined && value !== '')
            .map(([key, value]) => `${key}=${value}`)
            .join('&');

        const url = queryString 
            ? `${EndPoints.SALES_ORDER_DETAILS.GET_SALES_ORDER_DETAILS}?${queryString}`
            : EndPoints.SALES_ORDER_DETAILS.GET_SALES_ORDER_DETAILS;

        doGet({
            ...events,
            url: url,
            setFetching: setFetchingGetSalesOrderDetails
        });
    };

    // POST - Crear detalle
    const storeSalesOrderDetail = (detail: any, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.SALES_ORDER_DETAILS.STORE_SALES_ORDER_DETAIL,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            requestType: 'json',
            body: detail,
            setFetching: setFetchingStoreSalesOrderDetail
        });
    };

    // PUT - Actualizar detalle
    const updateSalesOrderDetail = (id: number, detail: any, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.SALES_ORDER_DETAILS.UPDATE_SALES_ORDER_DETAIL.replace(':id', id.toString()),
            body: detail,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            requestType: 'json',
            setFetching: setFetchingUpdateSalesOrderDetail
        });
    };

    // DELETE - Eliminar detalle
    const deleteSalesOrderDetail = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: EndPoints.SALES_ORDER_DETAILS.DELETE_SALES_ORDER_DETAIL.replace(':id', id.toString()),
            setFetching: setFetchingDeleteSalesOrderDetail
        });
    };

    return {
        fetchingGetSalesOrderDetails,
        fetchingStoreSalesOrderDetail,
        fetchingUpdateSalesOrderDetail,
        fetchingDeleteSalesOrderDetail,
        getSalesOrderDetails,
        storeSalesOrderDetail,
        updateSalesOrderDetail,
        deleteSalesOrderDetail
    };
};

export default useSalesOrderDetailService;

